import { TranslateHelper } from './../../_helpers/translate-helper';
import { Component, OnInit, Input } from '@angular/core';
import { DirectionService } from '@services/direction.service';
import * as _ from 'lodash';
import { SharedService } from '@app/_services/shared.service';
import { RouterLink } from '@angular/router';
import { ClickDirective } from '../../shared/directives/click.directive';
import { OwlPreventClickDirective } from '../../shared/directives/owl-prevent-click.directive';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgIf, NgFor } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-block-stores',
    templateUrl: './block-stores.component.html',
    styleUrls: ['./block-stores.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf,MatIconModule, CarouselModule, OwlPreventClickDirective, NgFor, ClickDirective, RouterLink]
})
export class BlockStoresComponent implements OnInit {
    sector;
    
    constructor(
        private direction: DirectionService,
        private shareService: SharedService,
        public translationHelper: TranslateHelper
    ) {
        this.sector = this.shareService.page;
    }

    @Input() companies;
    @Input() name = {
        en: "Our Stores",
        ar: "المتاجر"
    };
    @Input() loop = false;
    load = false;
    image = 'assets/images/nologo.png';
    layout: 'grid-4' | 'grid-4-sm' | 'grid-5' | 'horizontal' | 'custom' = 'custom';
    carouselOptions;
    carouselDefaultOptions: any = {
        lazyLoad:true,
        //items: 6,
        margin: 14,
        nav: false,
        dots: false,
        loop: this.loop || false,
        skip_validateItems : true,
        stagePadding: 1,
        rtl: this.direction.isRTL()
    };

    carouselOptionsByLayout: any = {
        'grid-4': {
            responsive: {
                1110: { items: 6, margin: 14 },
                930: { items: 6, margin: 10 },
                690: { items: 6, margin: 10 },
                400: { items: 6, margin: 10 },
                0: { items: 2.5 }
            }
        },
        'grid-4-sm': {
            responsive: {
                820: { items: 4, margin: 14 },
                640: { items: 3, margin: 10 },
                400: { items: 2, margin: 10 },
                0: { items: 2 }
            }
        },
        'grid-5': {
            responsive: {
                1110: { items: 5, margin: 12 },
                930: { items: 4, margin: 10 },
                690: { items: 3, margin: 10 },
                400: { items: 2, margin: 10 },
                0: { items: 2 }
            }
        },
        'custom': {
            responsive: {
                1210: { items: 7, margin: 14 },
                910: { items: 6, margin: 12 },
                730: { items: 5, margin: 10 },
                590: { items: 4, margin: 8 },
                400: { items: 3, margin: 4 },
                0: { items: 2 }
            }
        },
        horizontal: {
            items: 3,
            responsive: {
                1110: { items: 3, margin: 14 },
                930: { items: 3, margin: 10 },
                690: { items: 2, margin: 10 },
                0: { items: 2 }
            }
        }
    };



    ngAfterViewInit(): void {

        //this.carouselDefaultOptions.loop = this.loop;
        this.carouselDefaultOptions = { ...this.carouselDefaultOptions, loop: this.loop }
        this.load = true;
        this.carouselOptions = Object.assign({}, this.carouselDefaultOptions, this.carouselOptionsByLayout[this.layout]);

    }

    ngOnInit(): void {

    }
    imagebObjectKey(imageObject) {
      return _.findKey(imageObject);
    }

}
